module.exports = __webpack_public_path__ + "static/img/app5.8cd99231.png";